import { Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import CreateOrganization from "../CreateOrganization/CreateOrgMain/CreateOrganization";

import { TabContainer } from "../OrgBannerInfo/OrgBannerInfo.styles";
import OrganizationBubbles from "./OrganizationBubbles";
import { useNavigate } from "react-router";
// import { useAuth } from "apis/hooks/useAuth";

import {
  CenterPageSection,
  LeftPageSection,
  RightPageSection,
  Sections,
} from "./ProfilePageSections.styles";

import Organizations from "components/common/MyOrganizations/Organizations";
import Causes from "components/common/Causes/Causes";
import About from "components/common/AboutComponent/About";
import SecondNavbar from "components/common/SecondNavbar/SecondNavbar";
import { RetrieveForYouPage } from "apis/ActivityApi";
import ProfileEvents from "../Events/ProfileEvents";
import VolunteerSpotlight from "../VolunteerSpotlight/VolunteerSpotlight";
import SearchBarProfile from "../SearchBarProfile/SearchBarProfile";

function OrganizationHome() {
  const [tab, setTab] = useState("For-you");
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState("mostRecent");

  const handleChangeTab = (event: React.SyntheticEvent, newTab: string) => {
    setTab(newTab);
  };

  const handleSearch = (text: string) => {
    setSearchText(text);
  };

  const handleFilterChange = (newFilter: string) => {
    setFilter(newFilter);
  };

  function GetForYouPage() {
    const tableToReturn = [];
  }

  return (
    <div>
      <div>
        {/* <OrganizationBubbles /> */}
        <Sections>
          {/* <LeftPageSection>
                <About/>
                <Organizations/>
              </LeftPageSection> */}
          <CenterPageSection>
            <ProfileEvents />

            <SecondNavbar
              tab={tab}
              setTab={handleChangeTab}
              searchText={searchText}
              onSearch={handleSearch}
              onFilterChange={handleFilterChange}
            />
          </CenterPageSection>
          <RightPageSection>
            <VolunteerSpotlight />
          </RightPageSection>
        </Sections>
      </div>
    </div>
  );
}

export default OrganizationHome;
